@if (isTeaserFeatureEnabled()) {
    @if (isTeaserInitialised() && isLobbyLoaded()) {
        <div class="teaser-on-product-section">
            <cc-teaser-on-product [casinoProduct]="routeCurrentProduct" [categoryRoute]="routeCategoryType" />
        </div>
    } @else if (showSkeleton) {
        <cs-teaser-skeleton [enableNewSkeletonUI]="enableNewSkeletonUI" />
    }
}
